import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ConclusionPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Conclusion</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              The comprehensive knowledge of temporal LULC changes and their
              impacts on ecological fragility is quintessential for evolving
              appropriate strategies for conservation. The increasing trend of
              built-up cover from 0.02% to 2.11% due to economic activities led
              to a decrease in agriculture and forest cover from 1989-2019.
              Fragmentation analysis further confirms this trend by depicting
              habitat loss and increased fragmentation at the regional scale.
              Modeling has aided in analyzing the trends of past LU changes and
              predicting the probability of future LU. The region might
              experience a likely increase of 5% built-up cover (2029) at the
              cost of agriculture and forest areas. Systematic conservation by
              prioritization of ESR framework highlights 11% of the district
              under ESR 1, 29% under ESR 2, 15%, 45% under ESR 3, 4
              respectively. The findings of likely LU change will help regional
              planners, and decision-makers control LULC changes, arrest habitat
              fragmentation, safeguard natural resources, and frame common
              conservation strategies in the district.
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ConclusionPage;
